import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation])
export default new (class ArticleCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-article"
        this.sliderNextSelector = "carousel-article-next"
        this.sliderPrevSelector = "carousel-article-prev"
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}:not(.slider-article-large):not(.slider-article-comic):not(.slider-article-news)`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 2.5,
                spaceBetween: 16,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1.5,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    992: {
                        slidesPerView: 2.5,
                        spaceBetween: 16,
                    },
                    1641: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                },
            })
        })
        document.querySelectorAll(`.${this.sliderContainerSelector}.slider-article-large`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 2.5,
                spaceBetween: 16,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 'auto',
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                    },
                    1641: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                },
            })
        })
        document.querySelectorAll(`.${this.sliderContainerSelector}.slider-article-comic`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 2.5,
                spaceBetween: 16,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1.05,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 1.425,
                        spaceBetween: 16,
                    },
                    1641: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                },
            })
        })
        document.querySelectorAll(`.${this.sliderContainerSelector}.slider-article-news:not(.slider-article-press-center):not(.slider-article-mass-media)`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 3,
                spaceBetween: 16,
                loop: false,
                navigation: {
                    nextEl: item.closest('.slider').querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.closest('.slider').querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1.2,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    1199: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                },
            })
        })
        document.querySelectorAll(`.${this.sliderContainerSelector}.slider-article-news.slider-article-press-center`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 3,
                spaceBetween: 16,
                loop: false,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1.2,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    1199: {
                        slidesPerView: 3.132,
                        spaceBetween: 16,
                    },
                    1641: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                },
            })
        })
        document.querySelectorAll(`.${this.sliderContainerSelector}.slider-article-news.slider-article-mass-media:not(.slider-article-mass-media-search)`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 3,
                spaceBetween: 16,
                loop: false,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1.2,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    1199: {
                        slidesPerView: 2.5,
                        spaceBetween: 16,
                    },
                    1641: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                },
            })
        })
        document.querySelectorAll(`.${this.sliderContainerSelector}.slider-article-news.slider-article-mass-media.slider-article-mass-media-search`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            let mobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)');
            let swiper;
            let init = false;
        
            // Enable (for mobile)
            if(mobile.matches) {
                if (!init) {
                    swiper = new Swiper(item, {
                        slidesPerView: 3,
                        spaceBetween: 16,
                        loop: false,
                        // navigation: {
                        //     nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                        //     prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                        // },
                        centerInsufficientSlides: true,
                        breakpoints: {
                            300: {
                                init:true,
                                slidesPerView: 1.2,
                                spaceBetween: 28,
                            },
                        },
                    });
                }
            }
        })
    }
})()
